export enum FBClasses {
  inputPreview = 'FBInput-preview',
  nonOwner = 'FBInput-nonOwner',
  hoverVisibility = 'FBInput-hoverVisibility',
}
